import React from 'react';
import { Box } from '@mui/material';

const LoginBranding: React.FC = () => {
  return (
    <Box className="login-branding">
      <Box className="login-branding__logo">Loki</Box>
      <Box className="login-branding__tagline">
        <span>Insightful. Secure. Efficient.</span>
      </Box>
      <Box className="login-branding__subtitle">
        Your trusted partner in financial excellence
      </Box>
    </Box>
  );
};

export default LoginBranding;
